export default __webpack_public_path__ + "static/media/profile.f46f58e8.jpeg";